/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */

export type LicensePaymentStatus = (typeof LicensePaymentStatus)[keyof typeof LicensePaymentStatus];

export const LicensePaymentStatus = {
  PENDING: "PENDING",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
  CANCELED: "CANCELED",
  REFUNDED: "REFUNDED",
  IN_PROGRESS: "IN_PROGRESS",
  DISPUTED: "DISPUTED",
  PARTIALLY_REFUNDED: "PARTIALLY_REFUNDED",
  AUTHORIZED: "AUTHORIZED",
  EXPIRED: "EXPIRED",
} as const;
